module.exports = __webpack_public_path__ + "img/c5202009-5.3b7c55f8.jpg";